import { ComparisionCycle } from '../enums/comparision-cycle.enum';
import { ReportName } from '../enums/report-name.enum';
import { ReportStatus } from '../enums/report-status.enum';
import { MONTH_NUMBER_OPTIONS } from '../constants/month-options';
import { SelectOption } from './select-option';

export type ReportGenerateResponse = {
  reportId: number;
  status: ReportStatus;
  message: string;
};

export type ReportGenerateRequest = {
  nazwa: ReportName;
  dataOd?: string;
  dataDo?: string;
  cykl?: ComparisionCycle | null;
  rok?: number;
  doRoku?: number;
  polrocze?: number;
  doPolrocza?: number;
  kwartal?: number;
  doKwartalu?: number;
  miesiac?: number;
  doMiesiac?: number;
  rodzajWnioskuCode?: string[] | null;
  statusWniosku?: string[] | null;
};

export const REPORT_NAME_OPTIONS: SelectOption<ReportName>[] = [
  {
    label: 'Podstawowy raport wniosków',
    value: ReportName.BASIC_APPLICATION_REPORT,
  },
  {
    label: 'Raport porównawczy wniosków',
    value: ReportName.COMPARATIVE_APPLICATION_REPORT,
  },
];

export const REPORT_CYCLE_OPTIONS: SelectOption<ComparisionCycle>[] = [
  { label: 'Rok', value: ComparisionCycle.YEAR },
  { label: 'Pół roku', value: ComparisionCycle.HALF_YEAR },
  { label: 'Kwartał', value: ComparisionCycle.QUARTER },
  { label: 'Miesiąc', value: ComparisionCycle.MONTH },
];

export const REPORT_HALF_OPTIONS: SelectOption<number>[] = [
  { label: 'I półrocze', value: 1 },
  { label: 'II półrocze', value: 2 },
];

export const REPORT_QUARTER_OPTIONS: SelectOption<number>[] = [
  { label: 'I kwartał', value: 1 },
  { label: 'II kwartał', value: 2 },
  { label: 'III kwartał', value: 3 },
  { label: 'IV kwartał', value: 4 },
];

export const REPORT_MONTH_OPTIONS: SelectOption<number>[] =
  MONTH_NUMBER_OPTIONS;

export const REPORT_STATUS_ALL_OPTION: SelectOption<string> = {
  label: 'Wszystkie',
  value: 'ALL',
};

export const REPORT_DRAFT_STATUS = 'ROBC';

export const REPORT_STATUS_OPTIONS: SelectOption<string>[] = [
  { label: 'Wysłany', value: 'WYSL' },
  { label: 'Odebrany', value: 'ODBR' },
  { label: 'Roboczy', value: REPORT_DRAFT_STATUS },
];

export const BASIC_REPORT_STATUS_OPTIONS: SelectOption<string>[] =
  REPORT_STATUS_OPTIONS.filter(
    (option) => option.value !== REPORT_DRAFT_STATUS,
  );

export const COMPARATIVE_REPORT_STATUS_OPTIONS: SelectOption<string>[] =
  REPORT_STATUS_OPTIONS;

export const REPORT_STATUS_OPTIONS_WITH_ALL: SelectOption<string>[] = [
  REPORT_STATUS_ALL_OPTION,
  ...REPORT_STATUS_OPTIONS,
];
